import {
    GET_PLAN_GROUP_BEGIN, GET_PLAN_GROUP_SUCCESS, GET_PLAN_GROUP_FAILURE
} from '../constants/ActionTypes'

const initialState = {
    // Get Customer Plan Group
    customerPlanGroup: null,
    isLoadingCustomerPlanGroup: false,
    hasErrorCustomerPlanGroup: null
}

/**
 * Reducer function for managing the state of the customer plan group.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the customer plan group.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The new state of the customer plan group.
 */
const ReducerPlanGroup = (state = initialState, action) => {
    switch (action.type) {

    // Get Customer Plan Group
    case GET_PLAN_GROUP_BEGIN: {
        return {
            ...state,
            isLoadingCustomerPlanGroup: true
        }
    }
    case GET_PLAN_GROUP_SUCCESS: {
        return {
            ...state,
            customerPlanGroup: action.payload,
            isLoadingCustomerPlanGroup: false,
            hasErrorCustomerPlanGroup: null
        }
    }
    case GET_PLAN_GROUP_FAILURE: {
        return {
            ...state,
            selectedPlanGroup: null,
            isLoadingCustomerPlanGroup: false,
            hasErrorCustomerPlanGroup: action.payload
        }
    }

    default: return state

    }
}

export default ReducerPlanGroup